(function ()
{
    // Storage can throw (private browsing, cookies disabled, quota exceeded); never let that kill the script.
    function storageGet(key)
    {
        try
        {
            return localStorage.getItem(key);
        }
        catch (e)
        {
            return null;
        }
    }

    function storageSet(key, value)
    {
        try
        {
            localStorage.setItem(key, value);
        }
        catch (e)
        {
        }
    }

    async function postData(url = "", data = {}) {

        data["PageUrl"] = window.location.href,
        data["ReferringUrl"] = document.referrer

        const response = await fetch(url, {
          method: "POST", 
          mode: "no-cors", 
          cache: "no-cache", 
          // mode: "no-cors" silently downgrades Content-Type to text/plain, so the body is sent as text/plain JSON
          keepalive: true, // lets the tracking request complete even if the page is navigated away from or unloaded
          body: JSON.stringify(data), 
        });
    }

    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);	  
    let isAffiliate = (urlParams.get("utm_medium") === "affiliate") || urlParams.has("click_id");
    let isAmbassador = urlParams.has("irmp");

    let data = {};
    if(isAmbassador)
    {
        data["MediaPartnerId"] = urlParams.get("irmp"),
        data["AdId"] = urlParams.get("irad"),
        data["CampaignId"] = "12004"
    }
    else if(isAffiliate) 
    {	
        data["MediaPartnerId"] = urlParams.get("utm_campaign"),
        data["ClickId"] = urlParams.get("click_id"),
        data["CampaignId"] = urlParams.get("pla_campaign_id")
    }

    if(isAffiliate || isAmbassador)
    {
        data["Source"] = "Url"
        postData("https://api.equi.life/ecomm/impact/track", data);
        storageSet("ImpactCampaign", data["CampaignId"]);
        storageSet("ImpactPartner", data["MediaPartnerId"]);
    }
    else
    {
        let storageCampaign = storageGet("ImpactCampaign");
        if(storageCampaign)
        {
            data["MediaPartnerId"] = storageGet("ImpactPartner"),
            data["CampaignId"] = storageCampaign,
            data["Source"] = "Storage"
            postData("https://api.equi.life/ecomm/impact/track", data);
        }
    }
})();
